import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_library_item_by_id = async (library_id) => {
    if (!library_id) return { error: 'No library id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/library/id/${library_id}`,
        method: 'GET',
        credentials: 'include'
    })
}

export const update_library_item_by_id = async (library_id, payload) => {
    if (!library_id) return { error: 'No library id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/library/id/${library_id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include'
    })
}

export const create_library_item = async (payload) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/library`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include'
    })
}

export const delete_library_item_by_id = async (library_id) => {
    if (!library_id) return { error: 'No library id provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/library/id/${library_id}`,
        method: 'DELETE',
        credentials: 'include'
    })
}
